<template>
  <div class="account">
    <div class="infinite-list-wrapper" style="overflow: auto">
      <ul
        class="categoryContent"
        v-infinite-scroll="load"
        infinite-scroll-disabled="disabled"
      >
        <!-- <img :src="" style="width: 100%" /> -->

        <div
          :style="{
            background: `url(${accountData.cover})`,
            width: '100%',
            height: '210px',
          }"
        >
          <div class="avatar">
            <div style="color: #fff; padding-top: 30px; font-size: 20px">
              {{ contentParams.topic }}
            </div>
            <div class="avatarNumber">
              <div class="item" v-if="Number(accountData.liveNumber) > 0">
                <div class="fontWeight">
                  {{ accountData.liveNumber | formatReadNumber }}个直播
                </div>
              </div>
              <div
                v-if="Number(accountData.liveNumber) > 0"
                style="margin: 5px; border-right: 1px solid #fff"
              ></div>
              <div class="item" v-if="Number(accountData.videoNumber) > 0">
                <div class="fontWeight">
                  {{ accountData.videoNumber | formatReadNumber }}个视频
                </div>
              </div>
              <div
                v-if="Number(accountData.videoNumber) > 0"
                style="margin: 5px; border-right: 1px solid #fff"
              ></div>
              <div v-if="Number(accountData.newsNumber) > 0" class="item">
                <div class="fontWeight">
                  {{ accountData.newsNumber | formatReadNumber }}个资讯
                </div>
              </div>
              <div
                v-if="Number(accountData.newsNumber) > 0"
                style="margin: 5px; border-right: 1px solid #fff"
              ></div>
              <div class="item">
                <div class="fontWeight">
                  {{ accountData.clickNumber | formatReadNumber }}次点击
                </div>
              </div>
            </div>

            <div class="btn" @click="download">+关注</div>
            <div v-if="accountData.labels.length > 0" class="tagDiv">
              <span
                class="tagLabel"
                v-for="(item, key) in accountData.labels"
                :key="key"
              >
                {{ item }}
              </span>
            </div>
          </div>
        </div>
        <div class="categoryR">
          <div
            :class="{
              categoryRContent: true,
              categoryRActive: currentRecommend == item.index,
            }"
            v-for="(item, key) in recommendC"
            :key="key"
            @click="changeCurrent(item.index)"
          >
            {{ item.value }}
          </div>
        </div>
        <div v-if="currentRecommend == 'live'">
          <div class="categoryDiv">
            <div
              v-for="(item, key) in contentInfoList"
              :key="key"
              style="width: 49%; margin-right: 1%"
              @click="handleDetail(item.id)"
            >
              <div style="position: relative">
                <img
                  :src="item.cover"
                  style="
                    width: 100%;
                    border-radius: 10px;
                    min-height: 100px;
                    background: #e1e1e1;
                  "
                />
                <div
                  v-if="item.tag"
                  style="
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    position: absolute;
                    left: 0px;
                    top: 0px;
                  "
                >
                  {{ item.tag }}
                </div>
                <div style="position: absolute; left: 10px; bottom: 10px">
                  <div
                    v-if="item.status == 'LIVE'"
                    style="
                      display: flex;
                      border-radius: 5px;
                      color: #fff;
                      font-size: 12px;
                      background: rgba(1, 1, 1, 0.3);
                    "
                  >
                    <div
                      style="
                        background-color: rgba(255, 51, 102, 1);
                        border-radius: 5px;
                        width: 48px;
                        height: 25px;
                        line-height: 25px;
                        text-align: center;
                      "
                    >
                      直播中
                    </div>
                    <div
                      style="margin: 0px 10px; height: 25px; line-height: 25px"
                    >
                      {{ item.playNumber | formatReadNumber }}观看
                    </div>
                  </div>
                  <div
                    v-if="item.status == 'RESERVATION'"
                    style="
                      display: flex;
                      border-radius: 5px;
                      color: #fff;
                      font-size: 12px;
                      background: rgba(1, 1, 1, 0.3);
                    "
                  >
                    <div
                      style="
                        background-color: rgba(255, 204, 51, 1);
                        border-radius: 5px;
                        width: 48px;
                        height: 25px;
                        line-height: 25px;
                        text-align: center;
                      "
                    >
                      预约
                    </div>
                    <div
                      style="margin: 0px 10px; height: 25px; line-height: 25px"
                    >
                      {{ item.playNumber | formatReadNumber }}人想看
                    </div>
                  </div>
                  <div
                    v-if="item.status == 'LOOK_BACK'"
                    style="
                      display: flex;
                      border-radius: 5px;
                      color: #fff;
                      font-size: 12px;
                      background: rgba(1, 1, 1, 0.3);
                    "
                  >
                    <div
                      style="
                        background-color: rgba(153, 153, 204, 1);
                        border-radius: 5px;
                        width: 48px;
                        height: 25px;
                        line-height: 25px;
                        text-align: center;
                      "
                    >
                      回看
                    </div>
                    <div
                      style="margin: 0px 10px; height: 25px; line-height: 25px"
                    >
                      {{ item.playNumber | formatReadNumber }}观看
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="ellipsisT"
                style="margin-top: 5px; font-size: 16px; height: 40px"
              >
                {{ item.title }}
              </div>
              <div style="display: flex; text-align: center; margin: 15px 0px">
                <span
                  style="
                    color: #ffae18;
                    font-size: 12px;
                    background: rgba(255, 241, 240, 1);
                    padding: 0px 10px;
                    border-radius: 5px;
                    margin-right: 10px;
                  "
                  >社会</span
                >
                <span style="color: #888888; font-size: 13px">{{
                  item.authorName
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="currentRecommend == 'video'">
          <div class="categoryDiv">
            <div
              :key="key"
              v-for="(item, key) in contentInfoList"
              style="width: 48%; margin-right: 2%"
              @click="handleDetail(item.id)"
            >
              <div style="position: relative">
                <img
                  :src="item.cover"
                  :style="{
                    width: '100%',
                    height: '92px',
                  }"
                />
                <div
                  style="
                    position: absolute;
                    bottom: 5px;
                    left: 5px;
                    display: flex;
                    align-items: center;
                  "
                >
                  <div style="font-size: 17px; color: #000">
                    <svg-icon icon-class="u181" />
                  </div>
                  <span style="color: #fff; margin-left: 4px">{{
                    item.playNumber | formatReadNumber
                  }}</span>
                </div>
              </div>
              <div class="ellipsisT" style="margin-bottom: 10px">
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="currentRecommend == 'new'">
          <li
            class="categoryDiv"
            v-for="(item, key) in contentInfoList"
            :key="key"
            @click="handleDetail(item.id)"
          >
            <div
              style="display: flex; justify-content: space-between; width: 100%"
            >
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  flex-direction: column;
                  width: calc(100% - 120px);
                "
              >
                <div style="font-size: 16px; margin-right: 5px">
                  {{ item.title }}
                </div>
                <div style="display: flex; margin-top: 5px">
                  <span
                    style="
                      color: #ffae18;
                      font-size: 12px;
                      background: rgba(255, 241, 240, 1);
                      padding: 0px 10px;
                      border-radius: 5px;
                      margin-right: 10px;
                    "
                    >{{ item.categoryName }}</span
                  >
                  <div style="color: #999999; font-size: 12px">
                    {{ item.readNumber | formatReadNumber }}阅读
                    {{ item.createTime | filterData }}
                  </div>
                </div>
              </div>
              <img
                :src="`${item.smallCover}`"
                style="width: 120px; height: 80px"
              />
            </div>
          </li>
        </div>
      </ul>
    </div>
  </div>
</template>
<script>
import * as request from "@/utils/request";
import moment from "moment";
import "moment/locale/zh-cn";

export default {
  components: {},
  created() {
    this.contentParams.topic = this.$route.query.topic;
  },
  mounted() {
    this.initData();
  },
  computed: {
    noMore() {
      return (
        this.contentParams.page * this.contentParams.size >
        this.contentInfoListTotal
      );
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  filters: {
    formatReadNumber(val) {
      console.log(val);
      return val > 100000000
        ? `${(val / 100000000).toFixed(2)}亿`
        : val > 10000
        ? `${(val / 10000).toFixed(2)}万`
        : val;
    },
    filterData(time) {
      return moment(time).fromNow();
    },
  },
  data() {
    return {
      accountData: {
        cover: "",
        labels: [],
      },
      showDescri: true,
      currentRecommend: "live",
      recommendC: [],
      contentInfoList: [],
      contentInfoListTotal: 0,
      contentParams: {
        topic: "",
        page: 1,
        size: 10,
      },
    };
  },
  methods: {
    load() {
      this.loading = true;
      setTimeout(() => {
        this.contentParams.page += 1;
        if (this.currentRecommend == "video") {
          this.getVideoList();
        } else if (this.currentRecommend == "new") {
          this.geNewList();
        } else if (this.currentRecommend == "live") {
          this.geLiveList();
        }
        this.loading = false;
      }, 2000);
    },
    initData() {
      request
        .getTopics({
          topic: this.contentParams.topic,
        })
        .then((res) => {
          this.accountData = res.data;
          if (Number(this.accountData.liveNumber) > 0) {
            this.recommendC.push({
              index: "live",
              value: "直播",
            });
          }
          if (Number(this.accountData.videoNumber) > 0) {
            this.recommendC.push({
              index: "video",
              value: "视频",
            });
          }
          if (Number(this.accountData.newsNumber) > 0) {
            this.recommendC.push({
              index: "new",
              value: "资讯",
            });
          }
          if (this.recommendC.length > 0) {
            let topValue = this.recommendC[0].index;
            if ( topValue== "video") {
              this.getVideoList();
            } else if (topValue== "new") {
              this.geNewList();
            } else if (topValue == "live") {
              this.geLiveList();
            }
          }
        });
    },
    getVideoList() {
      request.getTopicsVideos(this.contentParams).then((res) => {
        this.contentInfoList = this.contentInfoList.concat(res.data.list);
        this.contentInfoListTotal = res.data.total;
      });
    },
    geNewList() {
      request.getTopicsNews(this.contentParams).then((res) => {
        this.contentInfoList = this.contentInfoList.concat(res.data.list);
        this.contentInfoListTotal = res.data.total;
      });
    },
    geLiveList() {
      request.getTopicsLives(this.contentParams).then((res) => {
        this.contentInfoList = this.contentInfoList.concat(res.data.list);
        this.contentInfoListTotal = res.data.total;
      });
    },
    parseUrl(url) {
      let imgArr = url.split(",");
      if (typeof imgArr === "string") {
        imgArr = [imgArr];
      }
      return imgArr;
    },
    handleDescri() {
      this.showDescri = !this.showDescri;
    },
    changeCurrent(val) {
      this.currentRecommend = val;
      this.contentInfoListTotal = 0;
      this.contentInfoList = [];
      this.contentParams = {
        ...this.contentParams,
        page: 1,
        size: 10,
      };
      if (val == "video") {
        this.getVideoList();
      } else if (val == "new") {
        this.geNewList();
      } else if (val == "live") {
        this.geLiveList();
      }
    },
    download() {
      this.$router.push({ path: `/download` });
    },
    handleDetail(id) {
      if (this.currentRecommend == "video") {
        this.$router.push({ path: `/video/player/${id}?type=VIDEO` });
      } else if (this.currentRecommend == "live") {
        this.$router.push({ path: `/live/player/${id}` });
      } else {
        this.$router.push({
          path: `/news/details/${id}`,
        });
      }
    },
  },
};
</script>
<style lang="less" scope>
.account {
  height: 100%;
  .avatar {
    width: 100%;
    text-align: center;
    .avatarNumber {
      display: flex;
      width: 100%;
      margin-top: 10px;
      justify-content: center;
      .item {
        text-align: center;
        .fontWeight {
          color: #fff;
        }
      }
    }
    .btn {
      margin: 20px auto;
      background: rgba(242, 242, 242, 1);
      color: #666666;
      width: 150px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      border-radius: 5px;
    }
    .tagDiv {
      margin-top: 10px;
      padding: 10px;
      height: 50px;
      white-space: nowrap;
      overflow-x: scroll;
      overflow-y: hidden;
      // ::-webkit-scrollbar:;
      .tagLabel {
        background: rgba(153, 153, 153, 1);
        color: #fff;
        border-radius: 20px;
        font-size: 14px;
        padding: 5px 10px;
        margin: 0px 5px;
      }
    }
  }
  .categoryR {
    display: flex;
    justify-content: center;
    color: #999999;
    // position: fixed;
    // top:3rem;
    height: 2.5em;
    // align-items: center;
    z-index: 9;
    width: 100%;
    div {
      width: 3rem;
      display: inline-block;
      margin: 0.5rem 0.5rem;
      background-size: contain;
      background-repeat: no-repeat;
    }
    .categoryRContent {
      margin: 0px 20px;
    }
    .categoryRActive {
      color: #000;
      font-weight: bold;
    }
    .categoryRActive::after {
      background: #379eeb;
      content: "";
      display: block;
      margin-left: -5px;
      margin-top: 5px;
      height: 2px;
      width: 40px;
    }
  }
  .categoryContent {
    height: 50rem;
    width: 100%;
    overflow-y: scroll;
    list-style: none;
    padding: 0px;
    .categoryDiv {
      padding: 8px;
      display: flex;
      flex-wrap: wrap;
    }
    .ellipsisT {
      letter-spacing: 0;
      overflow: hidden;
      display: -webkit-box;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2; /*要显示的行数*/
      -webkit-box-orient: vertical;
    }
  }
}
</style>